export default "__VITE_ASSET__BxI53z4r__"